// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"61":"0e764f01","286":"f5a933cd","604":"0e764f01","659":"0e764f01"}[chunkId] + ".chunk.css";
};